const ApiUrl = `http://domecqapi.trebolbit.com/api/`;

export default ApiUrl;
